/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Concurrent_ChangeInputs */

const vi_error_shop_concurrent_change = /** @type {(inputs: Error_Shop_Concurrent_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung này vừa được người khác lưu trước bạn. Tải lại trang để xem bản mới rồi sửa lại.`)
};

/**

* @param {Error_Shop_Concurrent_ChangeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_concurrent_change = /** @type {((inputs?: Error_Shop_Concurrent_ChangeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Concurrent_ChangeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_concurrent_change(inputs)
});